import { useContext } from 'react';
import { LoaderContext } from './LoaderContext';
export var useLoader = function () {
    var _a = useContext(LoaderContext), open = _a.open, close = _a.close;
    return [open, close];
};
